import { render, staticRenderFns } from "./Plotheader.vue?vue&type=template&id=1d91d51c&scoped=true"
import script from "./Plotheader.vue?vue&type=script&lang=js"
export * from "./Plotheader.vue?vue&type=script&lang=js"
import style0 from "./Plotheader.vue?vue&type=style&index=0&id=1d91d51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d91d51c",
  null
  
)

export default component.exports